import { Controller } from "@hotwired/stimulus";

export default class ScrollController extends Controller {
  connect() {
    const messages = document.getElementById("chat-history");
    this.observer = new MutationObserver(this.handleMutations.bind(this));
    this.observer.observe(messages, { childList: true, subtree: true });
    messages.scrollTop = messages.scrollHeight;
    this.setupDropDownHandle();
    this.preserveReactionScroll = (event) => {
      const targetId = event.target.getAttribute("target");
      if (!targetId?.startsWith("emoji_reaction_")) return;
      if (!messages.contains(document.getElementById(targetId))) return;

      const scrollTop = messages.scrollTop;
      const render = event.detail.render;
      event.detail.render = async (stream) => {
        await render(stream);
        if (!messages.isConnected) return;
        messages.scrollTop = scrollTop;
        requestAnimationFrame(() => {
          if (messages.isConnected) messages.scrollTop = scrollTop;
        });
      };
    };
    document.addEventListener("turbo:before-stream-render", this.preserveReactionScroll);
  }

  handleMutations(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        for (const node of mutation.addedNodes) {
          if (node.tagName === "TURBO-FRAME" && node.dataset.autoscrollBehavior) {
            this.resetScroll(node);
          }
        }
      }
    }
  }

  disconnect() {
    document.removeEventListener("turbo:before-stream-render", this.preserveReactionScroll);
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  /** Custom function */
  resetScroll(turboFrame) {
    const messages = document.getElementById("chat-history");
    const bottomOfScroll = messages.scrollHeight - messages.clientHeight;
    const upperScrollThreshold = bottomOfScroll - 500;
    // Scroll down if we're not within the threshold
    if (messages.scrollTop === 0 || messages.scrollTop > upperScrollThreshold) {
      messages.scrollTop = turboFrame.parentNode.offsetHeight;
    }
  }

  setupDropDownHandle() {
    this.element.addEventListener("scroll", function () {
      let dropdownElements = this.querySelectorAll("#messageMenuDropdown");

      for (const toggleEl of dropdownElements) {
        let dropdownInstance = bootstrap.Dropdown.getInstance(toggleEl);
        if (dropdownInstance) {
          dropdownInstance.hide();
        }
      }
    });
  }
}
